export default __webpack_public_path__ + "static/media/mockupwebapp2.f2e73562.jpg";